module.exports = __webpack_public_path__ + "img/img_nav_detail-w.22664a11.svg";